import React, { useState } from "react";
import { LOGO_TOKEN } from "../data/content";

const initials = (name) =>
  name.split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

/**
 * Real brand logo (transparent PNG via logo.dev) with a monogram fallback,
 * and the client name listed directly under the logo.
 */
export const BrandLogo = ({ name, domain, sector, testid }) => {
  const [failed, setFailed] = useState(!domain);
  const src = domain
    ? `https://img.logo.dev/${domain}?token=${LOGO_TOKEN}&format=png&size=200&retina=true`
    : null;

  return (
    <div
      className="group relative flex flex-col items-center justify-center text-center px-6 py-9 min-h-[190px] transition-colors duration-300"
      style={{ background: "var(--surface)" }}
      data-testid={testid}
    >
      <div className="flex items-center justify-center h-14 mb-4">
        {!failed ? (
          <img
            src={src}
            alt={`${name} logo`}
            loading="lazy"
            onError={() => setFailed(true)}
            className="max-h-14 w-auto max-w-[150px] object-contain transition-all duration-500 grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100"
          />
        ) : (
          <span
            className="display text-3xl tracking-tight w-14 h-14 flex items-center justify-center rounded-full"
            style={{ background: "var(--accent-soft)", color: "var(--accent)" }}
          >
            {initials(name)}
          </span>
        )}
      </div>
      <span className="text-sm font-medium" style={{ color: "var(--text)" }} data-testid={`${testid}-name`}>
        {name}
      </span>
      {sector ? (
        <span className="mt-1 text-[0.62rem] uppercase tracking-widest" style={{ color: "var(--muted-t)" }}>
          {sector}
        </span>
      ) : null}
    </div>
  );
};

export default BrandLogo;
